const formatNumber = (
    value: number,
    options: {
        style?: 'decimal' | 'currency' | 'percent';
        currency?: string;
        minimumFractionDigits?: number;
        maximumFractionDigits?: number;
        locale?: string;
    } = {}
): string => {
    const {
        style = 'decimal',
        currency = 'USD',
        minimumFractionDigits = 0,
        maximumFractionDigits = 2,
        locale = 'fr-CD',
    } = options;

    return new Intl.NumberFormat(locale, {
        style,
        currency,
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(value);
};

export default formatNumber;

// Usage examples:
// formatNumber(1234567.89) -> "1,234,567.89"
// formatNumber(1234567.89, { style: 'currency', currency: 'EUR' }) -> "€1,234,567.89"
// formatNumber(0.1234, { maximumFractionDigits: 3 }) -> "0.123"
